module.exports = __webpack_public_path__ + "img/member-4.7afe3134.png";